import React from 'react';
import { connect } from 'react-redux';
// Level editor imports
import { toggleBackgroundMode } from '../../../../../../actions/levelEditorActions';
import { BackgroundCategoryString } from '../../../../../../../GameKit/shared';
// Game(kit) imports
import gameKit from '../../../../../../../GameKit';
// Shared imports
import { LevelEditorModeEnum } from '../../../../../../shared';
import settings from '../../../../../../../settings';

class BtnBackground extends React.Component {
    handleClick = () => {
        // Toggle move mode
        const { levelEditor, dispatch } = this.props;
        if (levelEditor.mode !== LevelEditorModeEnum.BACKGROUND) {
            dispatch(toggleBackgroundMode());
            gameKit.levelEditor.startTileMode();
        }
    };

    render = () => {
        const { levelEditor, levelSettings } = this.props;
        const activeClass = levelEditor.itemSelectorCurrentCategory === BackgroundCategoryString ? 'active' : '';

        const hexA = levelSettings.backgroundColorA.toString(16).padStart(6, '0');
        const hexB = levelSettings.backgroundColorB.toString(16).padStart(6, '0');

        return (
            <button className={`btn-background-toggle ${activeClass}`} type="button" onClick={this.handleClick} style={{ backgroundImage: `linear-gradient(#${hexA},#${hexB})` }}>
                <img src={`${settings.assetsPath}img/icons/kwast.png`} alt="Achtergrond modus" title="Achtergrond modus" />
            </button>
        );
    };
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    levelEditor: state.levelEditor,
    levelSettings: state.levelSettings
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BtnBackground);
